import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgLoading = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 12 13"
    ref={ref}
    {...props}
  >
    <path
      fill="#E1E1E1"
      d="M6 .5a6 6 0 1 0 6 6 6.007 6.007 0 0 0-6-6M1.385 6.962a.462.462 0 0 1 0-.924h1.384a.462.462 0 0 1 0 .924zM4.042 9.11l-.98.98a.461.461 0 1 1-.654-.653l.98-.98a.462.462 0 0 1 .653.652m0-4.57a.46.46 0 0 1-.653 0l-.98-.98a.461.461 0 1 1 .654-.651l.98.98a.46.46 0 0 1-.001.652m2.42 6.574a.461.461 0 1 1-.924 0V9.731a.462.462 0 0 1 .924 0zm0-7.846a.462.462 0 0 1-.924 0V1.885a.462.462 0 0 1 .924 0zM9.59 10.09a.463.463 0 0 1-.653 0l-.98-.98a.462.462 0 0 1 .652-.653l.98.98a.46.46 0 0 1 .001.653m1.025-3.128H9.231a.462.462 0 0 1 0-.924h1.384a.461.461 0 1 1 0 .924"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLoading);
export default ForwardRef;
